{
  "product-happy-hour-dialog": {
    "buttons": {
      "close": "Fermer"
    },
    "text": {
      "happy-hour": "Happy hour",
      "to": "à"
    }
  },
  "product-promotion-dialog": {
    "buttons": {
      "close": "Fermer"
    },
    "text": {
      "from-date-to-date": "de {{from}} à {{to}}"
    }
  },
  "salon-service-selection": {
    "buttons": {
      "select": "Sélectionner",
      "selected": "Sélectionné"
    },
    "text": {
      "discount-details": "Détails des réductions",
      "minutes": "minutes"
    }
  }
}
